import React from 'react';
import { Navigate } from 'react-router-dom';
import ErrorModal from '../Common/ErrorModal';
import { useFetchQDeckUsersQuery } from '../../api/qdeckApi';
import { userSelector } from '../../selectors/authSelectors';
import { useSelector } from 'react-redux';

const Unauthorized = () => {
  const user = useSelector(userSelector);
  const { data: qdeckUsers = [], isLoading: areQDeckUsersLoading } = useFetchQDeckUsersQuery();

  if (areQDeckUsersLoading) {
    return null;
  }

  const isUserQDeckUser = qdeckUsers.some((qdeckUser) => qdeckUser.email === user.email);

  if (isUserQDeckUser) {
    return <Navigate to='/task-list' replace />;
  }
  return <ErrorModal errorMsg='You are not authorized to use QDeck :(' />;
};

export default Unauthorized;
